import React, { Component } from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';


export class RenterAdminTableHead extends Component {

  render() {
    const columnData = [
      {
        id: 'email', numeric: false, disablePadding: false, label: 'Email',
      },
      {
        id: 'firstname', numeric: false, disablePadding: false, label: 'Prénom',
      },
      {
        id: 'lastname', numeric: false, disablePadding: false, label: 'Nom',
      },
      {
        id: 'mobile', numeric: false, disablePadding: false, label: 'Téléphone',
      },
    ];

    return (

      <TableHead>
        <TableRow>
          {columnData.map(column => (
            <TableCell
              key={column.id}
              padding={column.disablePadding ? 'none' : 'normal'}
            >
              <TableSortLabel>
                {column.label}
              </TableSortLabel>
            </TableCell>
          ), this)}
          <TableCell />
        </TableRow>
      </TableHead>
    );
  }
}

export default RenterAdminTableHead;



// WEBPACK FOOTER //
// ./src/components/Users/RenterAdminTableHead.jsx